


//-------imports-----------
import React, { useState, useEffect } from "react";
import {
  Grid, Box,
  TextField,
  FormControl, Button,
  Stack,
  Breadcrumbs,
  Link,
  AppBar,
  Autocomplete
} from "@mui/material";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { useLocation } from "react-router-dom";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { SETTINGS_API_08, SETTINGS_API_26 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
const names = [
  { label: "Food Items", value: "F" },
  { label: "Beverages", value: "B" },
];

const MeasuringUnit = () => {
  //----------------hooks---------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error1, setError1] = useState(null);
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [dataitem, setDataitem] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const [errors, setErrors] = useState({});
  const isEdit = location.state?.actionText === "Edit";
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    MEASURINGUNITNAME: "",
    MEASURINGUNIT: "",
   
    MUCODE: "",
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        MEASURINGUNITNAME: selectedItem.MEASURINGUNITNAME,
        MEASURINGUNIT: selectedItem.MEASURINGUNIT,
     
        MUCODE: selectedItem.MUCODE ? parseInt(selectedItem.MUCODE) : null, 
       
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    fetchData();
  }, []);

  //------------------function------------

  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_26, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
      
        STS: CON_STATUS_ACTIVE,
      });
      setDataitem(result);
    } catch (err) {
      setError(err);
    }
  };
  // handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
  };
  //postapi
  const handleConfirmClick = async () => {
    const { MEASURINGUNITNAME, MEASURINGUNIT,  } =
      selectedItemDetails;

    const requiredFields = [
     
      { name: "MEASURINGUNIT", value: MEASURINGUNIT, label: "Measuring Unit" },
      { name: "MEASURINGUNITNAME", value: MEASURINGUNITNAME, label: "Measuring Unit Name " },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });

      setErrors(newError);
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage);
      setOpenErrorSnackbar(true);
      return;
    }

    if (dataitem) {
      const isDuplicate = dataitem.some((item) => {
        if (
          item.MUCODE != selectedItemDetails.MUCODE &&
          item.MEASURINGUNITNAME === MEASURINGUNITNAME
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setSnackbarMessage("Measuring Unit name already exists.");
        setOpenErrorSnackbar(true);
        return;
      }
    }

  

    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
  
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      MUCODE: selectedItemDetails.MUCODE || 0,
    
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_26, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        MEASURINGUNITNAME: "",
        MEASURINGUNIT: "",
    
       
        MUCODE: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      navigate("/Viewunits");
    }, 2000);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      MEASURINGUNITNAME: "",
      MEASURINGUNIT: "",
    
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const gotToView = () => {
    navigate("/Viewunits");
  };
  //validations
 

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Setting</Link>
                <Link underline="hover">Measuring Unit</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{ name: isEdit ? "Edit Measuring Unit" : "Create Measuring Unit" }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid container item spacing={2} xs={12} sm={12} md={6} lg={6}>
          
            <Grid item xs={12} sm={12}>
              <TextField
                label={
                  <span>
                   Measuring Unit Name
                    <span style={{ color: "red" }}> *</span>
                  </span>
                }
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                name="MEASURINGUNITNAME"
                value={selectedItemDetails.MEASURINGUNITNAME}
                onChange={handleInputChange}
                error={Boolean(errors.MEASURINGUNITNAME)}
                helperText={errors.MEASURINGUNITNAME}
              />
            </Grid>
          </Grid>
          <Grid container item spacing={2} xs={12} sm={12} md={6} lg={6}>
          

            <Grid item xs={12} sm={12}>
              <TextField
                label={
                    <span>
                     Measuring Unit
                      <span style={{ color: "red" }}> *</span>
                    </span>
                  }
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                name="MEASURINGUNIT"
                value={selectedItemDetails.MEASURINGUNIT}
                onChange={handleInputChange}
                error={Boolean(errors.MEASURINGUNIT)}
                helperText={errors.MEASURINGUNIT}
              />
            </Grid>
          </Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? "Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default MeasuringUnit;
